<template>
    <GamePageTpl
        :screenShotImages="this.screenShotImages"
        :slideImages="this.slideImages"
        :gameDescription="this.gameDescription"
    ></GamePageTpl>
</template>

<script>
import GamePageTpl from "../sub/GamePageTpl";

export default {
    name: "terra-land",
    components: {
        GamePageTpl
    },
    data: function() {
        return {
            screenShotImages: [
                {
                    img: require("@/assets/images/yx_pic1.jpg")
                },
                {
                    img: require("@/assets/images/yx_pic2.jpg")
                },
                {
                    img: require("@/assets/images/yx_pic3.jpg")
                },
                {
                    img: require("@/assets/images/yx_pic4.jpg")
                }
            ],
            slideImages: [
                {
                    img: require("@/assets/images/top_bg1.jpg"),
                    link: ""
                }
            ],
            gameDescription:
                "Legend Online  is an epic hybrid turn-based SRPG web game initially launched in November 2011. In Wartune, users may choose their avatars from three distinct classes (i.e., knight, mage or archer), individualize their avatars and lead legions of mercenaries through a fantasy-based storyline to fight battles and seek treasures. Users are able to level up their avatars by defeating monsters and improve their strengths by earning rewards. This game offers in-game purchases of virtual items to enhance the performance of their avatars."
        };
    }
};
</script>
